import React from 'react';
import './Modal_2.css';

import x from "../../../../asset/x.svg";
import backgroundImage from "../../../../asset/video_select_background_image.png";
import click_the_category from "../../../../asset/click_the_category.svg";

const Modal2 = ({ onClose }) => {
  return (
    <div className="design-modal-container_2" onClick={onClose}>
      <div className="design-modal-upper_2">
          <img
              src={x}
              alt={"x"}
              onClick={onClose}
              className="design-modal-upper-x_2"
              style={{
                  width: "auto",
                  height: "20px",
                  margin: "2%"
              }}
          />
      </div>
      <div className="design-modal-lower_2" onClick={(e) => e.stopPropagation()}>
        <img
            src={backgroundImage}
            alt={"background_image"}
            style={{
                width: "15vw",
                height: "auto",
                paddingTop: "1%",
                opacity: "40%"
            }}
        />
        <img
            src={click_the_category}
            alt={"click-the-image"}
            style={{
                width: "12vw",
                height: "auto",
                position: "absolute",
                left: "10%",
                top: "6%"
            }}
        />
      </div>
      <div className="design-modal-bottom_2">
      </div>
    </div>
  );
};

export default Modal2;